// SidebarView.jsx
import { useEffect, useState } from "react";
import { Sidebar } from "../components/sidebar_components/Sidebar";
import { Logo } from "../components/sidebar_components/Logo";
import { MenuItem } from "../components/sidebar_components/MenuItem";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import TroubleshootRoundedIcon from "@mui/icons-material/TroubleshootRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import ScoreboardRoundedIcon from "@mui/icons-material/ScoreboardRounded";
import MapRoundedIcon from "@mui/icons-material/MapRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import theme from "../theme";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Fab from "@mui/material/Fab";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import RegionPop from "./RegionPop";

function SidebarView() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < theme.breakpoints.mobile
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("Home");
  const [region, setRegion] = useState("Northwest");
  const [isRegionPopOpen, setIsRegionPopOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < theme.breakpoints.mobile);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const regionFromStorage = localStorage.getItem("region");
    if (regionFromStorage) {
      setRegion(regionFromStorage);
    }
  }, []);

  useEffect(() => {
    // Map paths to page titles
    const pathToTitle = {
      "/": "Home",
      "/players": "Players",
      "/comparison": "Comparison",
      "/events": "Events/Games",
      "/games": "Games",
      "/guide": "Guide",
      "/definitions": "Definitions",
      "/about": "About",
    };

    // Update current page based on location
    setCurrentPage(pathToTitle[location.pathname] || "XSM");
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handleRegionClick = () => {
    setIsRegionPopOpen(true);
  };

  const handleRegionPopClose = () => {
    setIsRegionPopOpen(false);
    // Refresh region from localStorage
    const regionFromStorage = localStorage.getItem("region");
    if (regionFromStorage) {
      setRegion(regionFromStorage);
    }
  };

  const sidebarContent = (
    <Sidebar
      isCollapse={isMobile ? !isSidebarOpen : false}
      textColor="white"
      mode="dark"
      width={"250px"}
      toggled={isMobile ? isSidebarOpen : true} // On desktop, always toggled open
      // pass isMobile if you need it inside Sidebar for styling adjustments
      isMobile={isMobile}
    >
      <Logo img="https://xsmbasketball.com/wp-content/uploads/thegem-logos/logo_033fe9e10695d37313702194ad3be9ed_2x.png">
        AdminMart
      </Logo>
      <div className="menu-section">
        <MenuItem
          icon={<HomeRoundedIcon />}
          link="/"
          selected={location.pathname === "/"}
        >
          Home
        </MenuItem>
        <MenuItem
          icon={<FolderSharedRoundedIcon />}
          link="/players"
          selected={location.pathname === "/players"}
        >
          HS Player Ratings
        </MenuItem>
        <MenuItem
          icon={<TroubleshootRoundedIcon />}
          link="/comparison"
          selected={location.pathname === "/comparison"}
        >
          HS Comparison
        </MenuItem>
        <MenuItem
          icon={<EmojiEventsRoundedIcon />}
          link="/events"
          selected={location.pathname === "/events"}
        >
          HS Events
        </MenuItem>
        <MenuItem
          icon={<FolderSharedRoundedIcon />}
          link="/ncaa-ratings"
          selected={location.pathname === "/ncaa-ratings"}
        >
          NCAA Player Ratings
        </MenuItem>
        <MenuItem
          icon={<SwapHorizRoundedIcon />}
          link="/transfer-portal"
          selected={location.pathname === "/transfer-portal"}
        >
          NCAA Transfer Portal
        </MenuItem>
        <MenuItem
          icon={<FolderSharedRoundedIcon />}
          link="/nba-ratings"
          selected={location.pathname === "/nba-ratings"}
        >
          NBA Player Ratings
        </MenuItem>
        <MenuItem
          icon={<TroubleshootRoundedIcon />}
          link="/nba-draft"
          selected={location.pathname === "/nba-draft"}
        >
          NBA Draft
        </MenuItem>
        <MenuItem
          icon={<SwapHorizRoundedIcon />}
          link="/nba-free-agency"
          selected={location.pathname === "/nba-free-agency"}
        >
          NBA Free Agency
        </MenuItem>
      </div>
      {/* <div className="menu-section">
        <MenuItem
          icon={<ScoreboardRoundedIcon />}
          link="/games"
          selected={location.pathname === "/games"}
        >
          Games
        </MenuItem>
      </div> */}
      <div className="menu-section">
        <MenuItem
          icon={<MapRoundedIcon />}
          link="/guide"
          selected={location.pathname === "/guide"}
        >
          Glossary
        </MenuItem>
        {/* <MenuItem
          icon={<MenuBookRoundedIcon />}
          link="/definitions"
          selected={location.pathname === "/definitions"}
        >
          Definitions
        </MenuItem> */}
        <MenuItem
          icon={<InfoRoundedIcon />}
          link="/about"
          selected={location.pathname === "/about"}
        >
          About
        </MenuItem>
      </div>
    </Sidebar>
  );

  return (
    <>
      {isMobile ? (
        <>
          <AppBar
            style={{
              position: "fixed",
              zIndex: 1300,
              backgroundColor: "#0a194a",
            }}
            position="static"
          >
            <Toolbar>
              <IconButton onClick={toggleSidebar}>
                <img
                  src="/xsmlgsm.PNG"
                  alt="XSM Logo"
                  style={{
                    padding: "0px",
                    marginRight: "5px",
                    width: "auto",
                    height: "40px",
                  }}
                />
              </IconButton>
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, cursor: "pointer" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ marginLeft: "0.1rem" }}>{currentPage}</span>
                </div>
              </Typography>
              <Button onClick={toggleSidebar} color="inherit">
                <MenuRoundedIcon />
              </Button>
            </Toolbar>
          </AppBar>
          {/* <Fab
            color="primary"
            onClick={toggleSidebar}
            style={{
              position: "fixed",
              top: "16px",
              right: "16px",
              zIndex: 1300,
            }}
          >
            <MenuRoundedIcon />
          </Fab> */}

          {/* Drawer for mobile */}
          <Drawer
            anchor="left"
            open={isSidebarOpen}
            onClose={closeSidebar}
            ModalProps={{ keepMounted: true }}
          >
            {sidebarContent}
          </Drawer>

          {/* <RegionPop open={isRegionPopOpen} onClose={handleRegionPopClose} /> */}
        </>
      ) : (
        // Desktop: fixed sidebar as before
        sidebarContent
      )}
    </>
  );
}

export default SidebarView;
